var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidneyCardE2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 158,
    height: 158,
    rx: 12,
    fill: "#fff",
    stroke: "#FBA240",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.015 115.629c-34.823-14.597-21.082-63.87 3.093-72.01 10.03-3.376 21.092 7.828 21.025 14.782-.032 3.007-1.593 5.941-3.222 8.996-2.134 4.014-4.385 8.235-3.43 13.12 1.683 8.6 3.568 23.114-1.288 30.002-4.856 6.89-9.738 7.808-16.178 5.11zM115.89 43.62c24.175 8.139 37.92 57.412 3.093 72.009-6.439 2.701-11.321 1.78-16.177-5.11-4.857-6.888-2.972-21.402-1.289-30.003.955-4.884-1.295-9.108-3.43-13.119-1.628-3.055-3.19-5.989-3.218-8.996-.07-6.954 10.995-18.158 21.021-14.781zM97.526 90.23l.225 3.176h.038l.01-.004a4.136 4.136 0 0 0-.539.115 4.989 4.989 0 0 0-1.516.72c-.93.656-2.295 2.115-2.295 5.798V119a2 2 0 0 1-2 2h-2.41a2 2 0 0 1-2-2v-18.965c0-5.626 2.275-9.07 4.984-10.99a11.43 11.43 0 0 1 4.68-1.921 7.96 7.96 0 0 1 .512-.064l.052-.007h.035c0-.003.006-.003.224 3.177zM67.472 90.23c-.218 3.176-.221 3.176-.224 3.176h-.039l-.01-.004.078.01a4.996 4.996 0 0 1 1.977.822c.93.66 2.295 2.118 2.295 5.801V119a2 2 0 0 0 2 2h2.411a2 2 0 0 0 2-2v-18.965c0-5.626-2.276-9.07-4.987-10.99a11.425 11.425 0 0 0-4.68-1.921 7.97 7.97 0 0 0-.513-.064l-.048-.007h-.035c0-.003-.004-.003-.225 3.177z",
    fill: "#BA7070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidneyCardE2);
export default __webpack_public_path__ + "static/media/kidneyCardE2.20093fc4.svg";
export { ForwardRef as ReactComponent };